module.exports = __webpack_public_path__ + "img/Hyundai-ioniq6.d63677a4.jpg";